"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionStorage = exports.LocalStorage = void 0;
/**
 * Created by George on 2018/5/25.
 */

var SessionStorage = exports.SessionStorage = {
  setItem: function setItem(key, value) {
    var valueStr = JSON.stringify(value);
    sessionStorage.setItem(key, valueStr);
  },
  getItem: function getItem(key) {
    var result = sessionStorage.getItem(key);
    return JSON.parse(result);
  },
  isItemExist: function isItemExist(key) {
    var result = sessionStorage.getItem(key);
    if (result === undefined || JSON.stringify(result) === '{}' || result === '' || result === null) {
      return false;
    }
    return true;
  },
  removeItem: function removeItem(key) {
    sessionStorage.removeItem(key);
  }
};
var LocalStorage = exports.LocalStorage = {
  setItem: function setItem(key, value) {
    var valueStr = JSON.stringify(value);
    localStorage.setItem(key, valueStr);
  },
  getItem: function getItem(key) {
    var result = localStorage.getItem(key);
    return JSON.parse(result);
  },
  isItemExist: function isItemExist(key) {
    var result = localStorage.getItem(key);
    if (result === undefined || JSON.stringify(result) === '{}' || result === '' || result === null) {
      return false;
    }
    return true;
  },
  removeItem: function removeItem(key) {
    localStorage.removeItem(key);
  }
};